import * as React from 'react'
import { Actions, useDispatch } from '../../stores/dashboard.store'
import { SettingsNavigationItems } from '../../config/nav'
import styles from './styles.module.css'
import Button from '../nura/button/button'
import BaseMenu from './base-menu'
import { signout } from '../../api-client/data'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'

const AccountMenu = ({ buttonRef, open, setOpen, user, setDrawer }) => {
    const dispatch = useDispatch()

    const navigate = (nav) => () => {
        setOpen(false)
        dispatch(Actions.NavigateDashboard, nav)
    }

    const logout = async () => {
        await signout()
        setOpen(false)
        dispatch(Actions.ResetState)

        window.location.reload()
    }

    const navigatePrivacy = () => window.open("https://flow.nuraml.com/privacy", "_blank")
    const navigateChangelog = () => window.open("https://flow.nuraml.com/docs/changelog/index", "_blank")

    const navigateTOS = () => window.open("https://flow.nuraml.com/tos", "_blank")
    const showTutorial = () => dispatch(Actions.SetShowTutorial, true)
    const showFeedback = () => dispatch(Actions.SetShowFeedbackForm, true)

    return (
        <BaseMenu buttonRef={buttonRef} open={open} setOpen={setOpen}>
            <div className={styles.accountMenuContainer}>
                <div className={styles.accountMenuHeader}>
                    <div>{user?.name}</div>
                    <div>{user?.email}</div>
                    <div style={{ marginTop: 10 }}><Button onClick={navigate({ nav: SettingsNavigationItems._id, view: SettingsNavigationItems.Plan })} variant="outline">Manage your Account</Button></div>
                </div>
                <div>
                    <div className={styles.accountMenuNoClick} style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(text-secondary)' }}>
                        <SupportAgentIcon />
                        <div>
                            <div>Support</div>
                            <div className={styles.accountMenuItemDescription}>support@nuraml.com</div>
                        </div>
                    </div>
                    <div className={styles.accountMenuTabbed}>
                        <div className={styles.tabbedItem}>
                            <div className={styles.tabbedItemContent} onClick={navigateChangelog}>Changelog</div>
                        </div>
                        <div className={styles.tabbedItem}>
                            <div className={styles.tabbedItemContent} onClick={showFeedback}>Submit Feedback</div>
                        </div>
                        <div className={styles.tabbedItem}>
                            <div className={styles.tabbedItemContent} onClick={navigatePrivacy}>Privacy Policy</div>
                        </div>
                        <div className={styles.tabbedItem} >
                            <div className={styles.tabbedItemContent} onClick={navigateTOS} style={{ borderBottom: '1px solid var(--border-secondary)' }}>Terms of service</div>
                        </div>
                    </div>
                    <div onClick={() => {
                        if (setDrawer) setDrawer(false)
                        showTutorial()
                    }} className={styles.accountMenuItemNoBorder} style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(text-secondary)' }}>
                        <QuestionMarkIcon />
                        <div>
                            <div>Tutorial</div>
                            <div className={styles.accountMenuItemDescription}>Understand the basics</div>
                        </div>
                    </div>
                </div>
                <div className={styles.accountMenuFooter} style={{ padding: '7px 0px' }}>
                    <div style={{ borderRadius: 0 }} className={styles.accountMenuItemNoBorder} onClick={logout}>Logout</div>
                </div>
            </div>
        </BaseMenu>
    )
}

export default AccountMenu